import {i18n} from '@/plugins/i18n'

export const settlementRequestType = {
    NORMAL: 0,
    CHARGE_WALLET: 1,

};

export const settlementRequestTypeStr = {
    NORMAL: i18n.t('settlement_request_type.normal'),
    CHARGE_WALLET: i18n.t('settlement_request_type.charge_wallet'),

    get(type) {
        let type_str = null;

        Object.keys(settlementRequestType).forEach(item => {
            if (settlementRequestType[item] === type) {
                type_str = settlementRequestTypeStr[item];
            }
        });

        return type_str;
    }
};

export const settlementRequestTypeVariant = type => {
    if (type === settlementRequestType.NORMAL) {
        return 'success';
    }

    if (type === settlementRequestType.CHARGE_WALLET) {
        return 'primary';
    }

    return 'warning';
};
